/**
 * Shared SR type + urgency labels (FEATURES.srFields). Session I's enums with
 * E's signed 1:1 label map. `other` is render-only — the backend coerces
 * legacy free-text `type` to it (preserving the original in `rawType`); it is
 * never OFFERED on the form. Billing/claim-question fold into General via the
 * form's Field hint. Urgency friendly labels map to the backend low|normal|high.
 */

export const SR_TYPES = [
  { value: "general", label: "General question" },
  { value: "quote_request", label: "New quote" },
  { value: "policy_change", label: "Policy change" },
  { value: "add_vehicle", label: "Add a vehicle" },
  { value: "cancellation", label: "Cancel a policy" }
];

export const SR_TYPE_LABELS = {
  general: "General question",
  quote_request: "New quote",
  policy_change: "Policy change",
  add_vehicle: "Add a vehicle",
  cancellation: "Cancel a policy",
  other: "Other"
};

export const URGENCY_OPTIONS = [
  { value: "low", label: "Whenever" },
  { value: "normal", label: "This week" },
  { value: "high", label: "Urgent" }
];

export const URGENCY_LABELS = { low: "Whenever", normal: "This week", high: "Urgent" };

/** Friendly SR type label; falls back to the raw value, then "General". */
export function srTypeLabel(type) {
  return SR_TYPE_LABELS[type] || type || "General";
}
